import { TCheckboxValue } from "@unlimint/admin-ui-kit"
import { TDictionaryItem } from "./types"

export const mapDictionaryToFilterMultiChoice = (
  dictionary: TDictionaryItem[]
): TCheckboxValue[] => {
  return dictionary.map((item) => {
    return {
      label: item.title,
      name: item.value,
    }
  })
}
